import React, { createContext, ReactNode } from 'react';
import { PostHogProvider } from 'posthog-js/react';
import config from 'src/config';
import { analyticsOptions } from './analyticsOptions';

const AnalyticsContext = createContext<null>(null);

interface AnalyticsProviderProps {
  children: ReactNode;
}

export const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({
  children,
}) => {
  return (
    <PostHogProvider apiKey={config.posthogApiKey} options={analyticsOptions}>
      <AnalyticsContext.Provider value={null}>
        {children}
      </AnalyticsContext.Provider>
    </PostHogProvider>
  );
};
